var map = {
	"./de.svg": 360,
	"./en.svg": 361,
	"./es-AR.svg": 362,
	"./es-US.svg": 363,
	"./hi.svg": 364,
	"./it-IT.svg": 365,
	"./iw.svg": 366,
	"./ro.svg": 367,
	"./ru.svg": 368,
	"./vi.svg": 369,
	"./zh-CN.svg": 370,
	"./zh-TW.svg": 371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 359;